<template>
  <div class="mt-3">
    <b-tabs class="nav-graphs-home" vertical pills>
      <b-tab :key="ix" v-for="(mod, ix) in modalidad">
        <template #title>
          <div class="profesion-tab">{{ $t(mod.name) }}</div>
        </template>
        <div class="row">
          <div class="col-auto">
            <RegenteGraph :n-data="mod"></RegenteGraph>
          </div>
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
  import { map, filter, groupBy, uniq, orderBy } from 'lodash'
  import RegenteGraph from './RegenteGraph.vue'

  export default {
    name: "RankingRegentes",
    props: {
      dataset: Array
    },
    components: {
      RegenteGraph
    },
    data() {
      return {
        filters: [
          {value: "consultor_pmf", text: 'ranking_home_consultores'},
          {value: "profesional_inf_tecnico_insp_ocular", text: 'ranking_home_profesional'},
          {value: "funcionario_aprobo_pmf", text: 'ranking_home_profesional_aprobo'},
          {value: "profesional_recomienda_aprueba_pmf", text: 'ranking_home_profesional_recomendo'},
          {value: "representante_legal", text: 'ranking_home_representante'}
        ]
      }
    },
    computed: {
      modalidad() {
        return map(this.filters, item => {
          let filtered = filter(this.dataset, d => (d[item.value] != '*No indica') && (d[item.value] != 'ND'))

          return {
            name: item.text,
            color: '#2e7832',
            data: (orderBy(map(groupBy(filtered, item.value+"_id"), (planes) => {
              return {                
                id: uniq(map(planes, item.value+"_id")).join('') + "_" + item.value+"_id",
                name: uniq(map(planes, item.value)).join(''),
                y: parseInt(planes.length)
              }
            }), ['y'], ['desc'])).slice(0,25)

          }
        })
      }
    }
  }
</script>